module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v("©\n            "), _c('span', [_vm._v("2017")]), _vm._v(" "), _c('a', {
    staticClass: "unstyled",
    attrs: {
      "href": "https://www.meituan.com/"
    }
  }, [_vm._v("美团网团购")]), _vm._v("\n            meituan.com\n            "), _c('a', {
    staticClass: "unstyled",
    attrs: {
      "href": "http://www.beianbeian.com/beianxinxi/283f39a9-4c00-427a-97ef-3c7a9e1e0af1.html",
      "target": "_blank"
    }
  }, [_vm._v("京ICP证070791号")]), _vm._v(" "), _c('span', [_vm._v("版本:" + _vm._s(_vm.version))])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-data"
  }, [_c('ul', {
    staticClass: "list-unstyled tel-data"
  }, [_c('li', [_c('h4', [_vm._v("商家咨询及电话验证请致电")]), _vm._v(" "), _c('h4', [_vm._v("400-660-1065")]), _vm._v(" "), _c('p', [_vm._v("周一到周日 09:00 - 21:00")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("消费者咨询请致电")]), _vm._v(" "), _c('h4', [_vm._v("10107888")]), _vm._v(" "), _c('p', [_vm._v("周一到周日 09:00 - 22:00")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("廉政邮箱")]), _vm._v(" "), _c('h4', [_vm._v("lianzheng@meituan.com")]), _vm._v(" "), _c('p', [_vm._v("周一到周日 09:00 - 21:00")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "footer-mark list-unstyled",
    attrs: {
      "ng-if": "$ctrl.showMark"
    }
  }, [_c('li', [_c('a', {
    staticClass: "footer-icon footer-icon-1",
    attrs: {
      "title": "备案信息",
      "href": "http://www.meituan.com/about/openinfo",
      "hidefocus": "true",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://p0.meituan.net/codeman/c144939183a31861e666846fb5f711733601.png"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-icon footer-icon-2",
    attrs: {
      "href": "http://t.knet.cn/index_new.jsp",
      "target": "_blank",
      "title": "可信网站认证",
      "rel": "nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://p1.meituan.net/codeman/bd7c7958fd27346dac8802826b863e435343.png"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-icon footer-icon-3",
    attrs: {
      "href": "http://www.bj315.org/xfwq/lstd/201209/t20120910_3344.shtml?dnrpluojqxbceiqq",
      "target": "_blank",
      "title": "12315消费争议",
      "rel": "nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://p1.meituan.net/codeman/bdf473bd76b1eb3f73b71a57a3afaf962232.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2096334","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/FooterBar.vue
// module id = 960
// module chunks = 0